/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useContext } from "react";
import SideNav from "../SideNav/SideNav";
import { AllContext } from "../../AllContext";
import { fetchUrl } from "../../config";
import Loading from "../Loading/Loading";

function TracingCode() {
  const { setShowAlert, setAlertText, setAlertVariant } = useContext(AllContext);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem("access_token");

  const [trackCodes, setTrackCodes] = useState({});
  const [inputValue, setInputValue] = useState({
    fbpixel: "",
    test_event: "",
    fb_capi_token: "",
    google: "",
  });

  // ✅ Fetch latest tracking codes
  const fetchTrackCodes = () => {
    fetch(`${fetchUrl}/api/track-codes/`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data[0]) {
          setTrackCodes(data[0]);
        }
      })
      .catch((err) => console.error("Failed to fetch codes:", err));
  };

  useEffect(() => {
    fetchTrackCodes();
  }, []);

  // ✅ Sync input with fetched codes
  useEffect(() => {
    setInputValue({
      fbpixel: trackCodes.fbpixel || "",
      test_event: trackCodes.test_event || "",
      fb_capi_token: trackCodes.fb_capi_token || "",
      google: trackCodes.google || "",
    });
  }, [trackCodes]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateCode = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const codeStatus = new FormData();
    codeStatus.append("fbpixel", inputValue.fbpixel);
    codeStatus.append("test_event", inputValue.test_event);
    codeStatus.append("fb_capi_token", inputValue.fb_capi_token);
    codeStatus.append("google", inputValue.google);

    fetch(`${fetchUrl}/api/track-codes/1/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      method: "PATCH",
      body: codeStatus,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.ok) {
          // ✅ Refresh codes after successful update
          fetchTrackCodes();
          setShowAlert(true);
          setAlertText("Update Success ✅");
          setAlertVariant("success");
        } else {
          setShowAlert(true);
          setAlertText("Fail to update ❌");
          setAlertVariant("danger");
        }
      })
      .catch(() => {
        setIsLoading(false);
        setShowAlert(true);
        setAlertText("Fail to update ❌");
        setAlertVariant("danger");
      });
  };

  return (
    <div>
      <div className="NavRow">
        {isLoading ? <Loading /> : null}
        <div>
          <SideNav />
        </div>
        <div className="bodyLayout ">
          <div className="py-5">
            <h4 className="text-center text-bg-dark">Tracking Codes</h4>
            <form onSubmit={handleUpdateCode}>
              <div className=" col-md-6 mx-auto">

                {/* Facebook Pixel */}
                <div className="mb-3 mt-5">
                  <label htmlFor="fbpixel">Facebook Pixel</label>
                  <input
                    onChange={handleInput}
                    value={inputValue.fbpixel}
                    type="text"
                    name="fbpixel"
                    placeholder="FB Pixel"
                    className="form-control mt-2"
                  />
                </div>

                {/* Test Event */}
                <div className="mb-3 mt-3">
                  <label htmlFor="test_event">Test Event Code</label>
                  <input
                    onChange={handleInput}
                    value={inputValue.test_event}
                    type="text"
                    name="test_event"
                    placeholder="FB Test Event Code"
                    className="form-control mt-2"
                  />
                </div>

                {/* FB CAPI Token */}
                <div className="mb-3 mt-3">
                  <label htmlFor="fb_capi_token">FB CAPI Token</label>
                  <input
                    onChange={handleInput}
                    value={inputValue.fb_capi_token}
                    type="text"
                    name="fb_capi_token"
                    placeholder="FB CAPI Token"
                    className="form-control mt-2"
                  />
                </div>

                {/* Google Code */}
                <div className="mb-3 mt-3">
                  <label htmlFor="google">Google Track</label>
                  <input
                    onChange={handleInput}
                    value={inputValue.google}
                    type="text"
                    name="google"
                    placeholder="Google Tag Manager"
                    className="form-control mt-2"
                  />
                </div>

                <input
                  className="my-3 btn btn-outline-primary"
                  type="submit"
                  value="Update"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TracingCode;
